<template>
  <div
    :id="isMagnoliaEdit ? null : anchor"
    :class="{ 'spacing-gap-reset pointer-events-none h-0': !isMagnoliaEdit }"
    class="anchor-target"
  >
    <div v-if="isMagnoliaEdit" class="editmode-info-box break-all">
      ANCHOR-NAME: {{ anchorName }}
    </div>
  </div>
</template>

<script>
export default {
  name: "AnchorComponent",
  props: ["anchorName"],
  computed: {
    anchor() {
      const anchorName = this.anchorName ?? "";
      return anchorName.startsWith("#") ? anchorName.replace("#", "") : anchorName;
    },
  },
};
</script>

<script setup>
const { isMagnoliaEdit } = useMagnoliaContext();
</script>

<style>
.anchor-target {
  scroll-margin-top: theme("spacing.28");
}
</style>
